import script from "./ProductivityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductivityTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductivityTable.vue?vue&type=style&index=0&id=a1913a06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1913a06"]])

export default __exports__